enum ctaTypes {
  baseButton = 'button',
  brandPrimary = 'brand-primary',
  primaryOrange = 'p-orange',
  primaryWhite = 'p-white',
  primaryBlack = 'p-black',
  secondaryBlack = 's-black',
  secondaryWhite = 's-white',
}

export default ctaTypes;
